import React, { Component, useState, useEffect } from "react";
import { useLocalStorage } from "./hooks/useLocalStorage";
import { ColorModeContext, useMode } from "./assets/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import Topbar from "./layouts/Topbar";
import AppRoutes from "./AppRoutes";
import Sidebar from "./layouts/Sidebar";
import axios from "axios";
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
  useMsalAuthentication,
  useAccount,
  useMsal,
} from "@azure/msal-react";
import {
  InteractionType,
  PublicClientApplication,
  EventType,
} from "@azure/msal-browser";
import RequestInterceptor from "./auth/RequestInterceptor";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LicenseInfo } from "@mui/x-license-pro";
import saveUserToDatabase from "./components/User/saveUserToDatabase";
import { IntlProvider } from 'react-intl';
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";

//import config from "../config";

LicenseInfo.setLicenseKey(
  "e3bcf6b64867053177be369d1df903edTz04MzMxMixFPTE3MzgzMjc3MjQwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);
const queryClient = new QueryClient({});
function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [userRoles, setUserRoles] = useState([]);
  useMsalAuthentication(InteractionType.Redirect);
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);


  const defaultLocale = useSelector((state) => state.language.language);

  const messages = require(`./translations/${defaultLocale}.json`) // en.json 
  const locale = defaultLocale
  console.log(locale);

  // console.log("process.env.REACT_APP_INSTANCE: ", process.env.REACT_APP_INSTANCE);
  // console.log("process.env.REACT_APP_CLIENT_ID: ", process.env.REACT_APP_CLIENT_ID);
  // console.log("process.env.REACT_APP_AUTHORITY: ", process.env.REACT_APP_AUTHORITY);
  // console.log("process.env.REACT_APP_REDIRECT_URI: ", process.env.REACT_APP_REDIRECT_URI);


  function getStorageValue(key, item) {
    const saved = localStorage.getItem(key);
    const configObject = JSON.parse(saved);
    const value = configObject ? configObject[item] : null;
    return value;
  }


// BEhövs detta?  -----------------------------
if (window.location.href.includes("localhost:44427")) {
  let instance =  process.env.REACT_APP_INSTANCE;
  let clientId = process.env.REACT_APP_CLIENT_ID; 
  let authority = process.env.REACT_APP_AUTHORITY;
  let redirectUri = process.env.REACT_APP_REDIRECT_URI;

  let config = {
    instance: instance || "",
    clientId: clientId || "",
    authority: authority || "",
    redirectUri: redirectUri || ""
  };

  window.RUNTIME_CONFIG = {
    REACT_APP_CLIENT_ID: config.clientId,
    REACT_APP_AUTHORITY: config.authority,
    REACT_APP_REDIRECT_URI: config.redirectUri,
    REACT_APP_INSTANCE: config.instance
  };
    
  localStorage.setItem('authConfig', JSON.stringify(config));
}

//_---------------------------------------



  // console.log("getStorageValue (app.js): ", getStorageValue("authConfig", "REACT_APP_INSTANCE"), getStorageValue("authConfig", "REACT_APP_CLIENT_ID"), getStorageValue("authConfig", "REACT_APP_AUTHORITY"), getStorageValue("authConfig", "REACT_APP_REDIRECT_URI"));
  // console.log("window.RUNTIME_CONFIG (app.js): ", window.RUNTIME_CONFIG);

  // console.log("window.RUNTIME_CONFIG === null (app.js): ", window.RUNTIME_CONFIG === null);
  // console.log("window.RUNTIME_CONFIG === undefined (app.js): ", window.RUNTIME_CONFIG === undefined);


  // console.log("clientId (app.js):", window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_CLIENT_ID") : window.RUNTIME_CONFIG.REACT_APP_CLIENT_ID);
  // console.log("authority (app.js):", window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_AUTHORITY") : window.RUNTIME_CONFIG.REACT_APP_AUTHORITY);
  // console.log("redirectUri (app.js):", window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_REDIRECT_URI") : window.RUNTIME_CONFIG.REACT_APP_REDIRECT_URI);
  // console.log("instanceConfig (app.js):", window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_INSTANCE") : window.RUNTIME_CONFIG.REACT_APP_INSTANCE);

  //############################################################################################################

  //Set instance
  const [instanceGermany, setInstanceGermany] = useLocalStorage("InstanceGermany", false);

  // useEffect(() => {
  let instanceConfig = window.RUNTIME_CONFIG === null || window.RUNTIME_CONFIG === undefined ? getStorageValue("authConfig", "REACT_APP_INSTANCE") : window.RUNTIME_CONFIG.REACT_APP_INSTANCE;
  console.log("instanceConfig: ", instanceConfig);
  if (instanceConfig === "Germany" && instanceGermany === false) {
    console.log("Germany instance set to true");
    setInstanceGermany(true);
  }
  if (instanceConfig !== "Germany" && instanceGermany === true) {
    console.log("Germany instance set to false");
    setInstanceGermany(false);
  }



  // if (instanceConfig === "Germany" && (defaultLocale === "" || defaultLocale === undefined)) {
  //     setDefaultLocale("de");
  // }
  // if (instanceConfig !== "Germany" && (defaultLocale === "" || defaultLocale === undefined)) {
  //     setDefaultLocale("sv");
  // }

  // }, []);
  //############################################################################################################

  // useEffect(() => {
  //   axios.get("/api/user").then((response) => {
  //     setUserRoles(response.data);
  //   }).catch((error) => console.log(error));
  // }, []);

  // const msalInstance = usems

  instance.addEventCallback((message) => {
    // Update UI or interact with EventMessage here
    if (message.eventType === EventType.LOGIN_SUCCESS) {
      console.log(message.payload);
    }
  });
  // saveUserToDatabase(account);

  return (
    <IntlProvider
      locale={locale}
      messages={messages}
    >
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthenticatedTemplate>
            <QueryClientProvider client={queryClient}>
              <RequestInterceptor>
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  {/*  */}

                  <main className="content">

                    <Topbar />
                    <ToastContainer />
                    <Routes>
                      {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                      })}

                    </Routes>
                  </main>
                </div>
                <ReactQueryDevtools initialIsOpen={false} />
              </RequestInterceptor>
            </QueryClientProvider>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <p> You are not signed in! Please sign in.</p>
          </UnauthenticatedTemplate>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </IntlProvider>
  );
}

export default App;
